import React, { createContext, ReactNode, useContext, useMemo } from "react";

import { DisplayType } from "./Picker.types";

interface IPickerDisplayContextValue {
    displayType: DisplayType;
    listMode: "list";
}

const PickerDisplayContext = createContext<IPickerDisplayContextValue>({
    displayType: "dropdown",
    listMode: "list",
});

interface IPickerDisplayContextProviderProps {
    displayType: DisplayType;
    children: ReactNode;
}

export function PickerDisplayContextProvider(
    props: IPickerDisplayContextProviderProps,
) {
    const { displayType, children } = props;
    const value = useMemo<IPickerDisplayContextValue>(
        () => ({ displayType, listMode: "list" }),
        [displayType],
    );
    return (
        <PickerDisplayContext.Provider value={value}>
            {children}
        </PickerDisplayContext.Provider>
    );
}

export function useDisplayType() {
    return useContext(PickerDisplayContext).displayType;
}

export function useIsDisplayType(type: DisplayType) {
    return useDisplayType() === type;
}

export function useDisplayMapping<T>(mapping: Record<DisplayType, T>): T {
    return mapping[useDisplayType()];
}
